const relatedRecipeCarousel = () => {
    const relatedRecipeCarousel = document.querySelector(
        ".js-related-recipe-carousel",
    );
    if (relatedRecipeCarousel) {
        const relatedRecipeScrollBar = document.querySelector(
            ".related-recipe__carousel-bar__thumb",
        );
        if (relatedRecipeScrollBar) {
            relatedRecipeScrollBar.style.width = `${(relatedRecipeCarousel.clientWidth * 100) / relatedRecipeCarousel.scrollWidth}%`;
        }
        //Scroll bar position setup
        relatedRecipeCarousel.addEventListener("scroll", () => {
            const horizontalScrollPosition = relatedRecipeCarousel.scrollLeft;
            if (relatedRecipeScrollBar) {
                relatedRecipeScrollBar.style.width = `${((relatedRecipeCarousel.clientWidth + horizontalScrollPosition) * 100) / relatedRecipeCarousel.scrollWidth}%`;
            }
        });
        //Get the width of the cards
        const cardWidth = relatedRecipeCarousel.querySelector(
            ".related-recipe__card",
        ).clientWidth;
        //Previous and next buttons setup
        const relatedRecipePrevious = document.getElementById(
            "related-recipe-previous",
        );
        const relatedRecipeNext = document.getElementById(
            "related-recipe-next",
        );
        if (relatedRecipePrevious) {
            relatedRecipePrevious.addEventListener("click", () => {
                relatedRecipeCarousel.scrollTo({
                    left: relatedRecipeCarousel.scrollLeft - cardWidth,
                    behavior: "smooth",
                });
            });
        }
        if (relatedRecipeNext) {
            relatedRecipeNext.addEventListener("click", () => {
                relatedRecipeCarousel.scrollTo({
                    left: relatedRecipeCarousel.scrollLeft + cardWidth,
                    behavior: "smooth",
                });
            });
        }
        //Mouse drag setup
        let isDragging = false;
        let startPosX = 0;
        let scrollLeft = 0;
        relatedRecipeCarousel.addEventListener("mousedown", (e) => {
            isDragging = true;
            startPosX = e.clientX - relatedRecipeCarousel.offsetLeft;
            scrollLeft = relatedRecipeCarousel.scrollLeft;

            relatedRecipeCarousel.style.cursor = "grabbing";

            e.preventDefault(); // Prevent text selection during dragging
        });

        document.addEventListener("mousemove", (e) => {
            if (!isDragging) return;

            const offsetX = e.clientX - startPosX;
            relatedRecipeCarousel.scrollLeft = scrollLeft - offsetX;
        });

        document.addEventListener("mouseup", () => {
            isDragging = false;
            relatedRecipeCarousel.style.cursor = "grab";
            relatedRecipeCarousel.style.transition = "scroll 0.3s ease-in-out";
        });
    }
};

document.addEventListener("DOMContentLoaded", relatedRecipeCarousel());

window.addEventListener("resize", () => {
    const relatedRecipeCarousel = document.querySelector(
        ".js-related-recipe-carousel",
    );
    if (relatedRecipeCarousel) {
        const relatedRecipeScrollBar = document.querySelector(
            ".related-recipe__carousel-bar__thumb",
        );
        if (relatedRecipeScrollBar) {
            relatedRecipeScrollBar.style.width = `${(relatedRecipeCarousel.clientWidth * 100) / relatedRecipeCarousel.scrollWidth}%`;
        }
        //Scroll bar position setup
        relatedRecipeCarousel.addEventListener("scroll", () => {
            const horizontalScrollPosition = relatedRecipeCarousel.scrollLeft;
            if (relatedRecipeScrollBar) {
                relatedRecipeScrollBar.style.width = `${((relatedRecipeCarousel.clientWidth + horizontalScrollPosition) * 100) / relatedRecipeCarousel.scrollWidth}%`;
            }
        });
        //Get the width of the cards
        const cardWidth = relatedRecipeCarousel.querySelector(
            ".related-recipe__card",
        ).clientWidth;
        //Previous and next buttons setup
        const relatedRecipePrevious = document.getElementById(
            "related-recipe-previous",
        );
        const relatedRecipeNext = document.getElementById(
            "related-recipe-next",
        );
        if (relatedRecipePrevious) {
            relatedRecipePrevious.addEventListener("click", () => {
                relatedRecipeCarousel.scrollTo({
                    left: relatedRecipeCarousel.scrollLeft - cardWidth,
                    behavior: "smooth",
                });
            });
        }
        if (relatedRecipeNext) {
            relatedRecipeNext.addEventListener("click", () => {
                relatedRecipeCarousel.scrollTo({
                    left: relatedRecipeCarousel.scrollLeft + cardWidth,
                    behavior: "smooth",
                });
            });
        }
        //Mouse drag setup
        let isDragging = false;
        let startPosX = 0;
        let scrollLeft = 0;
        relatedRecipeCarousel.addEventListener("mousedown", (e) => {
            isDragging = true;
            startPosX = e.clientX - relatedRecipeCarousel.offsetLeft;
            scrollLeft = relatedRecipeCarousel.scrollLeft;

            relatedRecipeCarousel.style.cursor = "grabbing";

            e.preventDefault(); // Prevent text selection during dragging
        });

        document.addEventListener("mousemove", (e) => {
            if (!isDragging) return;

            const offsetX = e.clientX - startPosX;
            relatedRecipeCarousel.scrollLeft = scrollLeft - offsetX;
        });

        document.addEventListener("mouseup", () => {
            isDragging = false;
            relatedRecipeCarousel.style.cursor = "grab";
            relatedRecipeCarousel.style.transition = "scroll 0.3s ease-in-out";
        });
    }
});
